import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M26 20v2H2v-2h24zm0-7v2H2v-2h24zm0-7v2H2V6h24z"
    />
  </React.Fragment>,
  `Menu`
);
